import { UserProfile } from "../types/user";
import { cn } from "../utils/cn";

interface AvatarProps {
  /** User profile object */
  profile: UserProfile;
  /** Size of the avatar in pixels */
  size?: "small" | "medium" | "large";
  /** Optional class names to apply */
  className?: string;
}

/**
 * Avatar component that displays either an image or user initials
 *
 * If avatarUrl is provided, displays the image.
 * Otherwise, displays the user's initials on a colored background.
 */
export const Avatar: React.FC<AvatarProps> = ({
  profile,
  size = "medium",
  className = "",
}) => {
  const sizeClasses = {
    small: "avatar-sm",
    medium: "avatar-md",
    large: "avatar-lg",
  };

  if (profile.avatarUrl) {
    return (
      <img
        src={profile.avatarUrl}
        alt={profile.fullName()}
        className={cn("avatar", sizeClasses[size], className)}
      />
    );
  }

  return (
    <div
      className={cn("avatar-initials", sizeClasses[size], className)}
      aria-label={profile.fullName() || "User profile"}
    >
      {profile.initials()}
    </div>
  );
};
